import React from 'react';
import { FDIcon } from '@facet-wealth/design';
import MuiIconButton from '@material-ui/core/IconButton';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useLogoutContext } from 'Context/LogoutContext';

const useStyles = buildUseStyles('Logout', (theme) => ({
  root: {
    '& > *': {
      // Every other button has theme.spacing(2) of horizontal padding, but this one only has theme.spacing(1.5) - fix that inconsistency
      padding: theme.spacing(2),
    },
  },
}));

export const Logout = () => {
  const { logout } = useLogoutContext();
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <MuiIconButton onClick={logout} disableRipple>
        <FDIcon icon="logout" color="primary" size="md" data-test="nav-button-logout" />
      </MuiIconButton>
    </div>
  );
};
